import { cn } from "@/lib/utils";

interface MetricsGridProps {
  children: React.ReactNode;
  className?: string;
}

function MetricsGrid({ children, className }: MetricsGridProps) {
  return (
    <section
      className={cn(
        "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4",
        className
      )}
    >
      {children}
    </section>
  );
}

export default MetricsGrid;
